import styled from "styled-components";

export const ModalCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    background-color: white;
    border-radius: 20px;
    padding: 56px 24px 32px;
    text-align: center;
`;

export const ModalCardTitle = styled.h4`
    font-size: 25px;
    margin: 0;
`;

export const ModalCardCopy = styled.p`
    font-size: 16px;
    padding: 0 16px;
    margin: 0;
`;
